<template>
	<cus-header>
		<div class="login-container flex" v-loading="loading">
			<div class="left">
				<img src="../../assets/login/left_image.png" alt="" />
			</div>
			<div class="right">
				<div class="flex-center">
					<div class="head flex-sb">
						<div>忘记密码</div>
					</div>
				</div>
				<div class="content">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="demo-ruleForm">
						<el-form-item label="" prop="email">
							<el-input placeholder="请输入邮箱" v-model="ruleForm.email">
								<template slot="prepend">
									<div class="col-center">
										<div class="emphasize">*</div>
										<div class="prepend-label">邮箱</div>
									</div>
								</template>
							</el-input>
						</el-form-item>
						<!-- <el-form-item prop="verify_code">
							<div class="flex-cb">
								<div class="verify-code">
									<el-input placeholder="验证码"
										v-model.number="ruleForm.verify_code"></el-input>
								</div>
								<div style="padding-left: 1.25rem;flex-grow: 1;width: 0;">
									<el-button :disabled="isSend" style="width:100%;height: 3rem;" type="primary" plain
										@click="send">{{isSend ? time+'s后重新获取': '获取验证码'}}</el-button>
								</div>
							</div>
						</el-form-item> -->
						<el-form-item label="" prop="password">
							<el-input placeholder="请输入密码" v-model="ruleForm.password" show-password>
								<template slot="prepend">
									<div class="col-center">
										<div class="emphasize">*</div>
										<div class="prepend-label">密码</div>
									</div>
								</template>
							</el-input>
						</el-form-item>
						<el-form-item label="" prop="checkPass">
							<el-input placeholder="请再次输入密码" v-model="ruleForm.checkPass" show-password>
								<template slot="prepend">
									<div class="col-center">
										<div class="emphasize">*</div>
										<div class="prepend-label">确认密码</div>
									</div>
								</template>
							</el-input>
						</el-form-item>
					</el-form>
				</div>
				<div class="floor row-center">
					<el-button color="#358BF6" @click="submitForm('ruleForm')">确认</el-button>
				</div>
				<div class="return-login" @click="backLogin">返回登录</div>
			</div>
		</div>
	</cus-header>
</template>

<script>
	import {
		sendCode,
		forgetPass
	} from '@/common/api/user.js'
	import {
		validatePhone,
		validateEmail,
		validateIdCard
	} from '../../utils/reg.js'
	export default {
		name: '',
		props: {

		},
		components: {

		},
		data() {
			let validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			let validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				time: 60,
				timer: null,
				isSend: false,
				checked: false,
				loading: false,
				ruleForm: {
					email: "",
					verify_code: "",
					password: "",
					checkPass: ""
				},
				rules: {
					email: [{
						required: true,
						validator: validateEmail,
						trigger: 'blur'
					}],
					verify_code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			let code = sessionStorage.getItem('vcode')
			if (code && Number(code) > 0) {
				this.time = code
				this.setTime()
			}
		},
		mounted() {

		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.loading = true
						try {
							const {
								data
							} = await forgetPass(this.ruleForm)
							this.loading = false
							this.$message.success('密码重置成功！')
							setTimeout(() => {
								this.$router.push('/')
							}, 1000)
						} catch (e) {
							this.loading = false
							//TODO handle the exception
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			backLogin() {
				this.$router.push('/')
			},
			// 验证码
			setTime() {
				this.isSend = true
				this.timer = setInterval(() => {
					this.time--
					sessionStorage.setItem('vcode', this.time)
					if (this.time <= 0) {
						setTimeout(() => {
							this.isSend = false
							this.time = 60
							clearInterval(this.timer)
						}, 1000)
					}
				}, 1000)
			},
			send() {
				this.$refs.ruleForm.validateField('email', (errorMessage) => {
					console.log(errorMessage)
					if (!errorMessage) {
						this.sendCode()
						this.setTime()
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			},
			// 发送验证码
			async sendCode() {
				try {
					const {
						data
					} = await sendCode({
						email: this.ruleForm.email,
						type: 2
					})
					this.$message.success('您的验证码已发送，请注意接收');
				} catch (e) {
					this.$message.error(JSON.stringify(e));
				}
			}
		}

	}
</script>

<style lang="scss" scoped>
	.login-container {
		border-radius: 0.625rem;
		overflow: hidden;
		box-shadow: 2px 4px 10px 4px rgba(92, 140, 199, .2);

		.left {
			width: 37.6rem;
			margin-right: -1px;

			// height: 43.75rem;
			img {
				width: 100%;
				margin-top: -4px;
			}
		}

		.right {
			flex-grow: 1;
			width: 0;
			background-color: white;
			padding: 2.5rem 7rem;

			.head {
				font-size: 1.35rem;
				font-weight: bold;
				position: relative;
				padding-top: 1.875rem;
				padding-left: 3rem;
				padding-right: 3rem;
				margin: 0 auto;
				color: #378DF7;
			}

			.head::after {
				content: "";
				display: block;
				width: 1.0416rem;
				height: 1.0416rem;
				position: absolute;
				left: .5rem;
				background: url(../../assets/login/left.png);
				bottom: .3rem;
			}

			.head::before {
				content: "";
				display: block;
				width: 1.0416rem;
				height: 1.0416rem;
				position: absolute;
				right: .5rem;
				background: url(../../assets/login/right.png);
				bottom: .3rem;
			}


			.flex-se {
				display: flex;
				align-items: flex-end;
				justify-content: space-between;
			}

			.return-login {
				font-size: 1rem;
				color: #4389E0;
				text-align: center;
				padding-top: 1.8rem;
			}

			.return-login:hover {
				cursor: pointer;
				text-decoration: underline;
			}

			.content {
				padding: 3rem 0 1.5rem;

				::v-deep .el-form-item {
					padding-bottom: 18px;
				}

				::v-deep .el-form-item__label {
					font-size: 1rem;
					font-weight: bold;
					padding-bottom: 0;
				}

				::v-deep .el-form-item__error {
					font-size: 1rem;
					padding-top: 12px;
				}

				::v-deep .el-input__inner {
					height: 3rem;
					font-size: 1rem;
				}

				::v-deep .el-input-group__prepend {
					background: none;
					border-right: 0 none;
					font-size: 1rem;
					color: #333;
				}

				.pc {
					display: flex;
				}

				.mobel {
					display: none;
				}

				.emphasize {
					color: red;
					padding-top: .6rem;
					padding-right: .4rem;
				}

				.prepend-selected {
					width: 100%;

					.prepend-selected-left {
						position: relative;
						border: 1px solid #DCDFE6;
						padding: 0 20px;
						white-space: nowrap;
						border-right: 0 none;
						height: 46px;
						line-height: 46px;
						font-size: 1rem;
						color: #333;
						border-radius: 4px 0 0 4px;
					}

					::v-deep .el-select {
						.el-input__inner {
							border-radius: 0 4px 4px 0;
						}
					}
				}

				.remember {
					font-size: 0.875rem;

					.forget {
						cursor: pointer;
						color: #4389E0;
					}

					.forget:hover {
						text-decoration: underline;
					}
				}

				.verify-code {
					width: 20rem;
				}

				.input-content {
					margin-bottom: 2rem;

					.input-prefix {
						position: relative;
						height: 100%;
						padding: 0 1.25rem;

						.input-icon {
							width: 1.125rem;
						}
					}

					.input-prefix::after {
						position: absolute;
						content: "";
						right: 0;
						height: 1.5rem;
						margin-top: -0.75rem;
						top: 50%;
						display: block;
						width: 1px;
						background-color: #DDDEE2;
					}
				}
			}

			.floor {
				width: 100%;

				::v-deep .el-button {
					width: 100%;
					height: 3.5rem;
					background: #358BF6;
					box-shadow: 1px 0.375rem 1.875rem 0px rgba(0, 114, 255, 0.3);
					border-radius: 0.25rem;
					color: white;
					font-size: 1rem;
				}
			}

			.register {
				padding-top: 1.875rem;
				color: #949BB0;

				.link {
					color: #4389E0;
					cursor: pointer;
				}

				.link:hover {
					text-decoration: underline;
				}
			}
		}
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.login-container {
			box-shadow: 2px 4px 10px 4px rgba(92, 140, 199, 0);

			.left {
				display: none;
			}

			.right {
				padding: 1rem 1.25rem;

				.content {
					padding-top: 2.5rem;

					.pc {
						display: none;
					}

					.mobel {
						display: flex;
					}

					.verify-code {
						width: 11rem;
					}
				}
			}
		}
	}
</style>